import { render, staticRenderFns } from "./BusinessQuotes.vue?vue&type=template&id=f793959e"
import script from "./BusinessQuotes.vue?vue&type=script&lang=js"
export * from "./BusinessQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardBusinessJobs: require('/opt/atlassian/pipelines/agent/build/components/dashboard/DashboardBusinessJobs.vue').default})
